import { Vector3 } from "three";
import { dead } from "@stores";
import { Player } from "@objects/entities";
class PlayerManager {
    static instance;
    player;
    /**
     * PlayerManager holds and performs updates on a player entity.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @private
     */
    constructor(scene, physicsWorld) {
        this.player = Player.getInstance(scene, physicsWorld);
    }
    /**
     * Perform a step on a player.
     * @param terrain The terrain, used for checks when shooting.
     * @param deltaTime The interval in seconds from the last frame to the current one.
     * @returns
     */
    step(targets, terrain, deltaTime) {
        if (this.isDead())
            return;
        this.player.step(targets, terrain, deltaTime);
        this.handleShooting(targets, terrain);
    }
    /**
     * Handle player death, if the player is dead.
     * @returns A boolean indicating whether or not the player is dead.
     */
    isDead() {
        if (this.player.isDead)
            return true;
        if (dead()) {
            this.player.kill();
            return true;
        }
        return false;
    }
    /**
     * Handle shooting on the player.
     * @param targets The possible targets the player can shoot at.
     * @param terrain The terrain, so that enemies behind terrain don't get hit.
     */
    handleShooting(targets, terrain) {
        if (!this.player.getInputController.getSHOOTING)
            return;
        const shootingOriginPosition = new Vector3();
        const shootingOriginDirection = new Vector3();
        this.player.getGun.getSkeleton.muzzle.getBone.getWorldPosition(shootingOriginPosition);
        this.player.getGun.getSkeleton.muzzle.getBone.getWorldDirection(shootingOriginDirection);
        shootingOriginDirection.negate();
        this.player.getGun.shoot(targets, terrain, shootingOriginPosition, shootingOriginDirection);
    }
    get getPlayer() {
        return this.player;
    }
    /**
     * Get or create a player manager.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @returns An instance of a player manager.
     */
    static getInstance(scene, physicsWorld) {
        if (!PlayerManager.instance)
            PlayerManager.instance = new PlayerManager(scene, physicsWorld);
        return PlayerManager.instance;
    }
}
export default PlayerManager;
